import { MultiSelectDesignTokens } from '@primeuix/themes/types/multiselect';

export const multiSelectPreset: MultiSelectDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
  },
  list: {
    gap: '1px',
  },
  colorScheme: {
    dark: {
      root: {
        borderColor: '{nspSlate.200}',
        background: 'transparent',
        color: '{nspSlate.0}',
        placeholderColor: '{nspSlate.0}',
        focusBorderColor: '{nspSky.300}',
        hoverBorderColor: '{nspSlate.500}',
        disabledBackground: 'transparent',
        disabledColor: '{nspSlate.400}',
      },
      option: {
        color: '{nspSlate.0}',
        focusBackground: '{nspSky.300}',
        selectedBackground: 'transparent',
        selectedColor: '{nspSlate.0}',
        selectedFocusColor: '{nspSlate.0}',
        selectedFocusBackground: '{nspSky.300}',
        gap: '8px',
        padding: '4px',
      },
      clearIcon: {
        color: '{nspSlate.50}',
      },
      dropdown: {
        color: '{nspSlate.50}',
      },
      overlay: {
        background: '{nspSlate.800}',
      },
    },
    light: {
      root: {
        borderColor: '{nspSlate.0}',
        background: '{nspSlate.0}',
        color: '{nspMist.900}',
        disabledColor: '{nspMist.400}',
        placeholderColor: '{nspMist.400}',
        focusBorderColor: '{nspSky.300}',
        hoverBorderColor: '{nspSlate.0}',
      },
      option: {
        color: '{nspSlate.950}',
        focusBackground: '{nspSky.300}',
        selectedBackground: '{nspSky.300}',
        selectedColor: '{nspSlate.950}',
        selectedFocusColor: '{nspSlate.950}',
        selectedFocusBackground: '{nspSky.300}',
      },
      clearIcon: {
        color: '{nspSlate.50}',
      },
      dropdown: {
        color: '{nspSlate.50}',
      },
      overlay: {
        background: '{nspSlate.0}',
      },
    },
  },
  css: ({ dt }) => `
    /* Disabled border colour */
    .p-multiselect.p-disabled {
      border-color: ${dt('nspSlate.400')};
    }
`,
};
